// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-5876ceea] {\n  font-size: 32px;\n  padding: 0;\n}\n.projects-card[data-v-5876ceea] {\n  background: #ffffff;\n  border: 1px solid #f2f2f2;\n  -webkit-box-shadow: 0px 0px 8px 0px #010a110a;\n          box-shadow: 0px 0px 8px 0px #010a110a;\n  padding: 16px;\n  border-radius: 16px;\n  width: 272px;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  font-family: \"Outfit\", sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
